export { default } from "./rightSideDetailsPanelContainer";
